import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { scrollToTop } from '@utils/usefulFuncs';
import { ROUTES } from '@constants/routes';
import { DocumentTemplateTool } from '@containers/DigitalAnalyst/DocumentTemplateTool';

const PageWrapper = styled.div`
  + div {
    width: 100%;
  }
`;

function DocumentCreatorPage({ modeId, tool }) {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <DocumentTemplateTool onGoBack={onGoBack} modeId={modeId} tool={tool} />
      </Body>
    </PageWrapper>
  );
}

export default DocumentCreatorPage;
